import { render } from "./ProspectActions.vue?vue&type=template&id=46b24238"
import script from "./ProspectActions.vue?vue&type=script&lang=js"
export * from "./ProspectActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__